"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = void 0;
const isArray = (variable) => {
    return Array.isArray(variable);
};
exports.isArray = isArray;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXMtYXJyYXkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbC9sb2Rhc2gtZnVuY3Rpb25zL2lzLWFycmF5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFPLE1BQU0sT0FBTyxHQUFHLENBQUMsUUFBYSxFQUFxQixFQUFFO0lBQ3hELE9BQU8sS0FBSyxDQUFDLE9BQU8sQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUNuQyxDQUFDLENBQUM7QUFGVyxRQUFBLE9BQU8sV0FFbEIifQ==